import { useMutation } from '../../../hooks';

import * as connectionsService from '../service';

export const useAvailablePlatforms = () => {
  const getListOfAvailablePlatforms = useMutation({
    mutationFn: connectionsService.getListOfAvailablePlatforms,
  });

  return {
    getListOfAvailablePlatforms,
  };
};
